/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetHarmfulFactorDto } from './GetHarmfulFactorDto';
import {
    GetHarmfulFactorDtoFromJSON,
    GetHarmfulFactorDtoFromJSONTyped,
    GetHarmfulFactorDtoToJSON,
} from './GetHarmfulFactorDto';
import type { GetExamArticleDto } from './GetExamArticleDto';
import {
    GetExamArticleDtoFromJSON,
    GetExamArticleDtoFromJSONTyped,
    GetExamArticleDtoToJSON,
} from './GetExamArticleDto';
import type { GetExamsPackageDto } from './GetExamsPackageDto';
import {
    GetExamsPackageDtoFromJSON,
    GetExamsPackageDtoFromJSONTyped,
    GetExamsPackageDtoToJSON,
} from './GetExamsPackageDto';
import type { GetExaminedDto } from './GetExaminedDto';
import {
    GetExaminedDtoFromJSON,
    GetExaminedDtoFromJSONTyped,
    GetExaminedDtoToJSON,
} from './GetExaminedDto';
import type { GetBatteryDto } from './GetBatteryDto';
import {
    GetBatteryDtoFromJSON,
    GetBatteryDtoFromJSONTyped,
    GetBatteryDtoToJSON,
} from './GetBatteryDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetVisitRegistrationDto } from './GetVisitRegistrationDto';
import {
    GetVisitRegistrationDtoFromJSON,
    GetVisitRegistrationDtoFromJSONTyped,
    GetVisitRegistrationDtoToJSON,
} from './GetVisitRegistrationDto';
import type { GetSynevoDto } from './GetSynevoDto';
import {
    GetSynevoDtoFromJSON,
    GetSynevoDtoFromJSONTyped,
    GetSynevoDtoToJSON,
} from './GetSynevoDto';

/**
 * 
 * @export
 * @interface GetExamDto
 */
export interface GetExamDto {
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    id: string;
    /**
     * 
     * @type {GetExaminedDto}
     * @memberof GetExamDto
     */
    examined?: GetExaminedDto | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetExamDto
     */
    psychologist?: GetUserDto | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExamDto
     */
    registrationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetExamDto
     */
    number: number;
    /**
     * 
     * @type {Array<GetExamArticleDto>}
     * @memberof GetExamDto
     */
    examArticles?: Array<GetExamArticleDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    pin?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    alarm: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetExamDto
     */
    changeDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    status?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExamDto
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExamDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    startVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    endVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    drivingLicense?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetExamDto
     */
    occupationalMedicineCategory?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    occupationalMedicineText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    type?: GetExamDtoTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExamDto
     */
    referralDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    employerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    employerAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    employmentPosition?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    employmentCandidate?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    employeePeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    sportsClubName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    sportsClubAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    sportsDiscipline?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExamDto
     */
    lossOfAbilityDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    kindOfScience?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExamDto
     */
    endScience?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    schoolName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    schoolAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    fieldOfStudy?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    schoolCandidate?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    schoolPeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    takenCareOf?: GetExamDtoTakenCareOfEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    referralFromEmployer?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    areHarmfulFactors?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    areResultsHarmfulFactors?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetExamDto
     */
    harmfulFactorsIds?: Array<string> | null;
    /**
     * 
     * @type {GetExamsPackageDto}
     * @memberof GetExamDto
     */
    examPackage?: GetExamsPackageDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    completed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    neurologist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    ophthalmologist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    laryngologist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    psychologistConsultation?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    psychiatrist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    ophthalmologistEnded?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    laryngologistEnded?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    neurologistEnded?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    psychiatristEnded?: boolean | null;
    /**
     * 
     * @type {GetBatteryDto}
     * @memberof GetExamDto
     */
    battery?: GetBatteryDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    healthcare?: GetExamDtoHealthcareEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    whoExamined?: GetExamDtoWhoExaminedEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    online?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    remote?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    inFacility?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    paid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    paymentType?: GetExamDtoPaymentTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    sellDocumentType?: GetExamDtoSellDocumentTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExamDto
     */
    paymentDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    external?: boolean | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetExamDto
     */
    creator?: GetUserDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    criticalPoint?: string | null;
    /**
     * 
     * @type {Array<GetHarmfulFactorDto>}
     * @memberof GetExamDto
     */
    harmulFactorsEntities?: Array<GetHarmfulFactorDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    articleWithAutoSupport?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetExamDto
     */
    supportingExaminationDict?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetExamDto
     */
    supportingExaminationDictSynevo?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetExamDto
     */
    supportingExaminationDictOther?: Array<string> | null;
    /**
     * 
     * @type {Array<GetSynevoDto>}
     * @memberof GetExamDto
     */
    synevo?: Array<GetSynevoDto> | null;
    /**
     * 
     * @type {GetVisitRegistrationDto}
     * @memberof GetExamDto
     */
    visit?: GetVisitRegistrationDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    hasSynevo?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetExamDto
     */
    articleHarmfulFactorSynevoOverrideDictIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamDto
     */
    visitId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamDto
     */
    active?: boolean;
}


/**
 * @export
 */
export const GetExamDtoTypeEnum = {
    Initial: 'Initial',
    Periodic: 'Periodic',
    Control: 'Control',
    PeriodicControl: 'PeriodicControl'
} as const;
export type GetExamDtoTypeEnum = typeof GetExamDtoTypeEnum[keyof typeof GetExamDtoTypeEnum];

/**
 * @export
 */
export const GetExamDtoTakenCareOfEnum = {
    Employee: 'Employee',
    Outwork: 'Outwork',
    Student: 'Student',
    OwnRequest: 'OwnRequest'
} as const;
export type GetExamDtoTakenCareOfEnum = typeof GetExamDtoTakenCareOfEnum[keyof typeof GetExamDtoTakenCareOfEnum];

/**
 * @export
 */
export const GetExamDtoHealthcareEnum = {
    Doctor: 'Doctor',
    Dentist: 'Dentist',
    Midwife: 'Midwife',
    Nurse: 'Nurse'
} as const;
export type GetExamDtoHealthcareEnum = typeof GetExamDtoHealthcareEnum[keyof typeof GetExamDtoHealthcareEnum];

/**
 * @export
 */
export const GetExamDtoWhoExaminedEnum = {
    Student: 'Student',
    Employee: 'Employee',
    Sanitary: 'Sanitary',
    EmployeeAndSanitary: 'EmployeeAndSanitary',
    StudentAndSanitary: 'StudentAndSanitary',
    SanitaryStudent: 'SanitaryStudent'
} as const;
export type GetExamDtoWhoExaminedEnum = typeof GetExamDtoWhoExaminedEnum[keyof typeof GetExamDtoWhoExaminedEnum];

/**
 * @export
 */
export const GetExamDtoPaymentTypeEnum = {
    Gotwka: 'Gotówka',
    Karta: 'Karta',
    Przelew: 'Przelew',
    Patno_mobilna: 'Płatność mobilna'
} as const;
export type GetExamDtoPaymentTypeEnum = typeof GetExamDtoPaymentTypeEnum[keyof typeof GetExamDtoPaymentTypeEnum];

/**
 * @export
 */
export const GetExamDtoSellDocumentTypeEnum = {
    Paragon: 'Paragon',
    Faktura: 'Faktura'
} as const;
export type GetExamDtoSellDocumentTypeEnum = typeof GetExamDtoSellDocumentTypeEnum[keyof typeof GetExamDtoSellDocumentTypeEnum];


/**
 * Check if a given object implements the GetExamDto interface.
 */
export function instanceOfGetExamDto(value: object): value is GetExamDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('alarm' in value) || value['alarm'] === undefined) return false;
    return true;
}

export function GetExamDtoFromJSON(json: any): GetExamDto {
    return GetExamDtoFromJSONTyped(json, false);
}

export function GetExamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExamDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'examined': json['examined'] == null ? undefined : GetExaminedDtoFromJSON(json['examined']),
        'psychologist': json['psychologist'] == null ? undefined : GetUserDtoFromJSON(json['psychologist']),
        'registrationDate': json['registrationDate'] == null ? undefined : (new Date(json['registrationDate'])),
        'description': json['description'] == null ? undefined : json['description'],
        'number': json['number'],
        'examArticles': json['examArticles'] == null ? undefined : ((json['examArticles'] as Array<any>).map(GetExamArticleDtoFromJSON)),
        'pin': json['pin'] == null ? undefined : json['pin'],
        'alarm': json['alarm'],
        'changeDate': json['changeDate'] == null ? undefined : (new Date(json['changeDate'])),
        'status': json['status'] == null ? undefined : json['status'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'startVersion': json['startVersion'] == null ? undefined : json['startVersion'],
        'endVersion': json['endVersion'] == null ? undefined : json['endVersion'],
        'drivingLicense': json['drivingLicense'] == null ? undefined : json['drivingLicense'],
        'occupationalMedicineCategory': json['occupationalMedicineCategory'] == null ? undefined : json['occupationalMedicineCategory'],
        'occupationalMedicineText': json['occupationalMedicineText'] == null ? undefined : json['occupationalMedicineText'],
        'type': json['type'] == null ? undefined : json['type'],
        'referralDate': json['referralDate'] == null ? undefined : (new Date(json['referralDate'])),
        'employerName': json['employerName'] == null ? undefined : json['employerName'],
        'employerAddress': json['employerAddress'] == null ? undefined : json['employerAddress'],
        'employmentPosition': json['employmentPosition'] == null ? undefined : json['employmentPosition'],
        'employmentCandidate': json['employmentCandidate'] == null ? undefined : json['employmentCandidate'],
        'employeePeriod': json['employeePeriod'] == null ? undefined : json['employeePeriod'],
        'sportsClubName': json['sportsClubName'] == null ? undefined : json['sportsClubName'],
        'sportsClubAddress': json['sportsClubAddress'] == null ? undefined : json['sportsClubAddress'],
        'sportsDiscipline': json['sportsDiscipline'] == null ? undefined : json['sportsDiscipline'],
        'lossOfAbilityDate': json['lossOfAbilityDate'] == null ? undefined : (new Date(json['lossOfAbilityDate'])),
        'kindOfScience': json['kindOfScience'] == null ? undefined : json['kindOfScience'],
        'endScience': json['endScience'] == null ? undefined : (new Date(json['endScience'])),
        'schoolName': json['schoolName'] == null ? undefined : json['schoolName'],
        'schoolAddress': json['schoolAddress'] == null ? undefined : json['schoolAddress'],
        'fieldOfStudy': json['fieldOfStudy'] == null ? undefined : json['fieldOfStudy'],
        'schoolCandidate': json['schoolCandidate'] == null ? undefined : json['schoolCandidate'],
        'schoolPeriod': json['schoolPeriod'] == null ? undefined : json['schoolPeriod'],
        'takenCareOf': json['takenCareOf'] == null ? undefined : json['takenCareOf'],
        'referralFromEmployer': json['referralFromEmployer'] == null ? undefined : json['referralFromEmployer'],
        'areHarmfulFactors': json['areHarmfulFactors'] == null ? undefined : json['areHarmfulFactors'],
        'areResultsHarmfulFactors': json['areResultsHarmfulFactors'] == null ? undefined : json['areResultsHarmfulFactors'],
        'harmfulFactorsIds': json['harmfulFactorsIds'] == null ? undefined : json['harmfulFactorsIds'],
        'examPackage': json['examPackage'] == null ? undefined : GetExamsPackageDtoFromJSON(json['examPackage']),
        'completed': json['completed'] == null ? undefined : json['completed'],
        'neurologist': json['neurologist'] == null ? undefined : json['neurologist'],
        'ophthalmologist': json['ophthalmologist'] == null ? undefined : json['ophthalmologist'],
        'laryngologist': json['laryngologist'] == null ? undefined : json['laryngologist'],
        'psychologistConsultation': json['psychologistConsultation'] == null ? undefined : json['psychologistConsultation'],
        'psychiatrist': json['psychiatrist'] == null ? undefined : json['psychiatrist'],
        'ophthalmologistEnded': json['ophthalmologistEnded'] == null ? undefined : json['ophthalmologistEnded'],
        'laryngologistEnded': json['laryngologistEnded'] == null ? undefined : json['laryngologistEnded'],
        'neurologistEnded': json['neurologistEnded'] == null ? undefined : json['neurologistEnded'],
        'psychiatristEnded': json['psychiatristEnded'] == null ? undefined : json['psychiatristEnded'],
        'battery': json['battery'] == null ? undefined : GetBatteryDtoFromJSON(json['battery']),
        'healthcare': json['healthcare'] == null ? undefined : json['healthcare'],
        'whoExamined': json['whoExamined'] == null ? undefined : json['whoExamined'],
        'online': json['online'] == null ? undefined : json['online'],
        'remote': json['remote'] == null ? undefined : json['remote'],
        'inFacility': json['inFacility'] == null ? undefined : json['inFacility'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
        'sellDocumentType': json['sellDocumentType'] == null ? undefined : json['sellDocumentType'],
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
        'external': json['external'] == null ? undefined : json['external'],
        'creator': json['creator'] == null ? undefined : GetUserDtoFromJSON(json['creator']),
        'criticalPoint': json['criticalPoint'] == null ? undefined : json['criticalPoint'],
        'harmulFactorsEntities': json['harmulFactorsEntities'] == null ? undefined : ((json['harmulFactorsEntities'] as Array<any>).map(GetHarmfulFactorDtoFromJSON)),
        'articleWithAutoSupport': json['articleWithAutoSupport'] == null ? undefined : json['articleWithAutoSupport'],
        'supportingExaminationDict': json['supportingExaminationDict'] == null ? undefined : json['supportingExaminationDict'],
        'supportingExaminationDictSynevo': json['supportingExaminationDictSynevo'] == null ? undefined : json['supportingExaminationDictSynevo'],
        'supportingExaminationDictOther': json['supportingExaminationDictOther'] == null ? undefined : json['supportingExaminationDictOther'],
        'synevo': json['synevo'] == null ? undefined : ((json['synevo'] as Array<any>).map(GetSynevoDtoFromJSON)),
        'visit': json['visit'] == null ? undefined : GetVisitRegistrationDtoFromJSON(json['visit']),
        'hasSynevo': json['hasSynevo'] == null ? undefined : json['hasSynevo'],
        'articleHarmfulFactorSynevoOverrideDictIds': json['articleHarmfulFactorSynevoOverrideDictIds'] == null ? undefined : json['articleHarmfulFactorSynevoOverrideDictIds'],
        'visitId': json['visitId'] == null ? undefined : json['visitId'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function GetExamDtoToJSON(value?: GetExamDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'examined': GetExaminedDtoToJSON(value['examined']),
        'psychologist': GetUserDtoToJSON(value['psychologist']),
        'registrationDate': value['registrationDate'] == null ? undefined : ((value['registrationDate'] as any).toISOString()),
        'description': value['description'],
        'number': value['number'],
        'examArticles': value['examArticles'] == null ? undefined : ((value['examArticles'] as Array<any>).map(GetExamArticleDtoToJSON)),
        'pin': value['pin'],
        'alarm': value['alarm'],
        'changeDate': value['changeDate'] == null ? undefined : ((value['changeDate'] as any).toISOString()),
        'status': value['status'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate'] as any).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'startVersion': value['startVersion'],
        'endVersion': value['endVersion'],
        'drivingLicense': value['drivingLicense'],
        'occupationalMedicineCategory': value['occupationalMedicineCategory'],
        'occupationalMedicineText': value['occupationalMedicineText'],
        'type': value['type'],
        'referralDate': value['referralDate'] == null ? undefined : ((value['referralDate'] as any).toISOString()),
        'employerName': value['employerName'],
        'employerAddress': value['employerAddress'],
        'employmentPosition': value['employmentPosition'],
        'employmentCandidate': value['employmentCandidate'],
        'employeePeriod': value['employeePeriod'],
        'sportsClubName': value['sportsClubName'],
        'sportsClubAddress': value['sportsClubAddress'],
        'sportsDiscipline': value['sportsDiscipline'],
        'lossOfAbilityDate': value['lossOfAbilityDate'] == null ? undefined : ((value['lossOfAbilityDate'] as any).toISOString()),
        'kindOfScience': value['kindOfScience'],
        'endScience': value['endScience'] == null ? undefined : ((value['endScience'] as any).toISOString()),
        'schoolName': value['schoolName'],
        'schoolAddress': value['schoolAddress'],
        'fieldOfStudy': value['fieldOfStudy'],
        'schoolCandidate': value['schoolCandidate'],
        'schoolPeriod': value['schoolPeriod'],
        'takenCareOf': value['takenCareOf'],
        'referralFromEmployer': value['referralFromEmployer'],
        'areHarmfulFactors': value['areHarmfulFactors'],
        'areResultsHarmfulFactors': value['areResultsHarmfulFactors'],
        'harmfulFactorsIds': value['harmfulFactorsIds'],
        'examPackage': GetExamsPackageDtoToJSON(value['examPackage']),
        'completed': value['completed'],
        'neurologist': value['neurologist'],
        'ophthalmologist': value['ophthalmologist'],
        'laryngologist': value['laryngologist'],
        'psychologistConsultation': value['psychologistConsultation'],
        'psychiatrist': value['psychiatrist'],
        'ophthalmologistEnded': value['ophthalmologistEnded'],
        'laryngologistEnded': value['laryngologistEnded'],
        'neurologistEnded': value['neurologistEnded'],
        'psychiatristEnded': value['psychiatristEnded'],
        'battery': GetBatteryDtoToJSON(value['battery']),
        'healthcare': value['healthcare'],
        'whoExamined': value['whoExamined'],
        'online': value['online'],
        'remote': value['remote'],
        'inFacility': value['inFacility'],
        'paid': value['paid'],
        'paymentType': value['paymentType'],
        'sellDocumentType': value['sellDocumentType'],
        'paymentDate': value['paymentDate'] == null ? undefined : ((value['paymentDate'] as any).toISOString()),
        'external': value['external'],
        'creator': GetUserDtoToJSON(value['creator']),
        'criticalPoint': value['criticalPoint'],
        'harmulFactorsEntities': value['harmulFactorsEntities'] == null ? undefined : ((value['harmulFactorsEntities'] as Array<any>).map(GetHarmfulFactorDtoToJSON)),
        'articleWithAutoSupport': value['articleWithAutoSupport'],
        'supportingExaminationDict': value['supportingExaminationDict'],
        'supportingExaminationDictSynevo': value['supportingExaminationDictSynevo'],
        'supportingExaminationDictOther': value['supportingExaminationDictOther'],
        'synevo': value['synevo'] == null ? undefined : ((value['synevo'] as Array<any>).map(GetSynevoDtoToJSON)),
        'visit': GetVisitRegistrationDtoToJSON(value['visit']),
        'hasSynevo': value['hasSynevo'],
        'articleHarmfulFactorSynevoOverrideDictIds': value['articleHarmfulFactorSynevoOverrideDictIds'],
        'visitId': value['visitId'],
        'active': value['active'],
    };
}

